(function () {
  var CONTAINER_ID = 'tca-cart-upsell';
  var REOPEN_FLAG = 'tca_reopen_drawer';
  var MAX_RECS = 2;

  function routesBase() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function money(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function firstImage(product) {
    if (product.images && product.images.length && product.images[0]) {
      return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
    }
    if (product.featured_image) return product.featured_image;
    return null;
  }

  function firstAvailableVariant(product) {
    if (!product.variants || !product.variants.length) return null;
    var avail = product.variants.filter(function (v) { return v.available; });
    return avail.length ? avail[0] : product.variants[0];
  }

  function buildCard(product) {
    var variant = firstAvailableVariant(product);
    if (!variant) return null;
    var img = firstImage(product);
    var card = document.createElement('div');
    card.className = 'tca-upsell-card';
    card.innerHTML =
      '<a href="/products/' + product.handle + '" class="tca-upsell-img">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" width="60" height="60">' : '') +
      '</a>' +
      '<div class="tca-upsell-info">' +
        '<a href="/products/' + product.handle + '" class="tca-upsell-title">' + product.title + '</a>' +
        '<span class="tca-upsell-price">' + money(variant.price) + '</span>' +
      '</div>' +
      '<button type="button" class="tca-upsell-add" data-variant-id="' + variant.id + '" aria-label="Add ' + product.title.replace(/"/g, '&quot;') + ' to cart">Add</button>';
    return card;
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = '...';
    // Only buttons the "Goes well with" widget renders carry this attribute
    // (set from the pairs_with_discount_code metafield) -- generic cart-drawer
    // recommendations never do, so this can't accidentally discount an
    // unrelated combination.
    var discountCode = btn.getAttribute('data-discount-code');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (discountCode) {
          // Same redirect-to-apply pattern this theme already uses for
          // AURA10 (snippets/ajax-cart.liquid) -- applies the code to the
          // session and lands back on this page, so the shopper never has
          // to type a code themselves.
          try { sessionStorage.setItem('tca_discount_applied', '1'); } catch (e) {}
          window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(window.location.pathname);
          return;
        }
        // Full reload rather than a partial DOM swap: the drawer's own item
        // list has no dedicated Section Rendering API endpoint distinct from
        // the cart *page*'s section (confirmed live -- fetching
        // ?section_id=cart-section returns the cart page's table markup, a
        // different structure from the drawer's card markup, and swapping it
        // in silently wiped the drawer's item list). A reload is guaranteed
        // correct everywhere (item list, cart icon count, everything)
        // instead of guessing at this theme's undocumented internals.
        try { sessionStorage.setItem(REOPEN_FLAG, '1'); } catch (e) {}
        window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  function renderCartUpsell() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          container.innerHTML = '';
          return;
        }
        var cartProductIds = cart.items.map(function (i) { return i.product_id; });
        var anchorId = cart.items[cart.items.length - 1].product_id;
        return fetch('/recommendations/products.json?product_id=' + anchorId + '&limit=6&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var recs = (data.products || []).filter(function (p) {
              return cartProductIds.indexOf(p.id) === -1 && p.available;
            }).slice(0, MAX_RECS);
            if (!recs.length) {
              container.innerHTML = '';
              return;
            }
            var wrap = document.createElement('div');
            wrap.className = 'tca-upsell-wrap';
            wrap.innerHTML = '<p class="tca-upsell-heading">You might also like</p>';
            var row = document.createElement('div');
            row.className = 'tca-upsell-row';
            recs.forEach(function (p) {
              var card = buildCard(p);
              if (card) row.appendChild(card);
            });
            wrap.appendChild(row);
            container.innerHTML = '';
            container.appendChild(wrap);
          });
      })
      .catch(function () { container.innerHTML = ''; });
  }

  // Single delegated click handler for every ".tca-upsell-add" button on the
  // page, whether it's dynamically rendered here (cart drawer recommendations)
  // or statically rendered by Liquid (product-page "Goes well with" widget,
  // snippets/product-template-pairs-with.liquid). Attached once at load time,
  // so it works regardless of when/how a button entered the DOM -- no
  // per-button wiring needed on either side.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.tca-upsell-add');
    if (!btn || btn.disabled) return;
    addToCart(btn.getAttribute('data-variant-id'), btn);
  });

  // Re-render whenever ANY cart mutation happens, regardless of which theme
  // code path triggered it (product page add, quick-buy, drawer qty change,
  // etc.) -- all of them go through Shopify's Ajax Cart API endpoints, so
  // hooking window.fetch here is more robust than reverse-engineering this
  // theme's specific internal event bus (which this snippet doesn't use).
  var originalFetch = window.fetch;
  window.fetch = function () {
    var urlArg = arguments[0];
    var url = typeof urlArg === 'string' ? urlArg : (urlArg && urlArg.url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    var result = originalFetch.apply(this, arguments);
    if (isCartMutation) {
      result.then(function () {
        setTimeout(renderCartUpsell, 300);
      });
    }
    return result;
  };

  document.addEventListener('DOMContentLoaded', function () {
    renderCartUpsell();
    // Re-open the drawer after a reload triggered by our own "Add" button,
    // so a shopper adding a recommended item doesn't lose their place.
    // Defensive: only calls .open() if the theme's ajax-cart element actually
    // exposes it -- if not, this silently does nothing rather than throwing.
    try {
      if (sessionStorage.getItem(REOPEN_FLAG) === '1') {
        sessionStorage.removeItem(REOPEN_FLAG);
        var drawer = document.querySelector('ajax-cart');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      }
    } catch (e) {}
  });
})();
